var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrawerArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.22,
    height: 4.83,
    viewBox: "0 0 8.22 4.83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.2.206a.7.7,0,0,0,0,.984L3.654,4.63a.7.7,0,0,0,.959.022l3.4-3.389A.695.695,0,1,0,7.032.278L4.111,3.155,1.187.2A.7.7,0,0,0,.2.206Z",
    fill: "#707070",
    stroke: "#707070",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrawerArrow);
export default __webpack_public_path__ + "static/media/drawer-arrow.7f03d347.svg";
export { ForwardRef as ReactComponent };